import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Paper from '@mui/material/Paper';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { COLUMN_MODE_PANEL_HEIGHT_PERCENT, ROW_MODE_PANEL_WIDTH_PERCENT } from '../../../constants/constants';
import { useIsRowLayoutMode } from '../../../hooks/useIsRowLayoutMode';
import { DEFAULT_BACKGROUND_COLOR } from '../../../styles/colors';
import { darkTheme } from '../../../styles/materialTheme';
import { MttStagingControlsHeaderContainer } from './mttStagingControlsHeaderContainer';
import { MttStagingInfoDisplay } from './mttStagingInfoDisplay';
import { MttStagingPlayersSubSectionContainer } from './mttStagingPlayersSubSectionContainer';
import { MttStagingTablesSubSectionContainer } from './mttStagingTablesSubSectionContainer';
const PAPER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: none !important;
  background-color: ${DEFAULT_BACKGROUND_COLOR} !important;
`;
export const MttStagingMainPanel = () => {
    const isRowLayoutMode = useIsRowLayoutMode();
    const containerCss = useMemo(() => css(css `
          padding: 8px;
          right: 0;
          display: flex;
          flex-direction: column;
        `, isRowLayoutMode
        ? css `
              width: ${100 - ROW_MODE_PANEL_WIDTH_PERCENT}%;
              height: 100%;
            `
        : css `
              width: 100%;
              height: ${100 - COLUMN_MODE_PANEL_HEIGHT_PERCENT}%;
            `), [isRowLayoutMode]);
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: darkTheme, children: _jsxs("div", { "data-testid": 'main-content', css: containerCss, children: [_jsx(MttStagingControlsHeaderContainer, {}), _jsxs(Paper, { component: 'section', css: PAPER_CSS, children: [_jsx(MttStagingTablesSubSectionContainer, {}), _jsx(MttStagingInfoDisplay, {}), _jsx(MttStagingPlayersSubSectionContainer, {})] })] }) }) }));
};
